module.exports = __webpack_public_path__ + "media/assets/user-silhouette-7baa024f5d3dd4332ccd26d79dbe4665.png";